export default __webpack_public_path__ + "static/media/img6.3e8d7170.jpeg";